import { NPC_FUNNEL_ENABLE_UPDATED_ANNUAL_FEE } from '../constants';

import { getFeatureVariables, ifFeatureFlagOn } from './feature-flags';

export const useAnnualFee = () => {
  const featureFlagOn = ifFeatureFlagOn(NPC_FUNNEL_ENABLE_UPDATED_ANNUAL_FEE);
  const featureVariables = getFeatureVariables(
    NPC_FUNNEL_ENABLE_UPDATED_ANNUAL_FEE
  );

  const defaultAnnualFee = 39;

  if (featureFlagOn) {
    const isProduction = window.location.hostname === 'www.prosper.com';
    return isProduction
      ? (featureVariables?.prod_annual_fee ?? defaultAnnualFee)
      : (featureVariables?.test_annual_fee ?? defaultAnnualFee);
  }

  return defaultAnnualFee;
};
